
// Bei jQuery Skripten, unbedingt importieren:
import $ from 'jquery';
import Dropzone from "dropzone";

const $dropzones = $('.dropzone');
if ($dropzones.length) {
  $dropzones.each((_, el) => {
    const dropzone = new Dropzone(el, {
      url: '/api/upload',

      // Translated dropzone messages
      dictDefaultMessage: "Dateien zum Hochladen hier ablegen",
      dictFallbackMessage: "Ihr Browser unterstützt keine Drag'n'Drop-Datei-Uploads.",
      dictFallbackText: "Bitte verwenden Sie das untenstehende Formular, um Ihre Dateien wie früher hochzuladen.",
      dictFileTooBig: "Datei ist zu groß ({{filesize}}MiB). Maximale Dateigröße: {{maxFilesize}}MiB.",
      dictInvalidFileType: "Sie können keine Dateien dieses Typs hochladen.",
      dictResponseError: "Der Server antwortete mit Statuscode {{statusCode}}",
      dictCancelUpload: "Upload abbrechen",
      dictCancelUploadConfirmation: "Sind Sie sicher, dass Sie diesen Upload abbrechen möchten?",
      dictRemoveFile: "Datei entfernen",
      dictMaxFilesExceeded: "Sie können keine weiteren Dateien hochladen.",
    });
    const $el = $(el);
    const $form = $el.parents('form');
    const $submit = $form.find('[type="submit"]');

    $form.on('submit', e => {
      if (dropzone.getActiveFiles().length) {
        e.preventDefault();
      }
    });
    dropzone.on("addedfile", file => {
      $submit.prop('disabled', true);
    });
    dropzone.on('success', file => {
      $submit.prop('disabled', false);
      const apiResponse = JSON.parse(file.xhr.response);
      console.log(apiResponse);
      $.each(apiResponse.files, (_, file) => {
        $form.append('<input type="hidden" name="' + $el.data('name') + '[]" value="' + file.file + '" />');
      });
    })
  })
}

